import { CSSObject } from '@emotion/react';

/**
 * Applies full width to spot.
 */
export const fullWidthSpot: CSSObject = {
    gridColumn: 'span 12',
};
